import styled from "styled-components"

export const Disabled = styled.span`
  display: inline-block;
  pointer-events: none;
  opacity: 0.5;
`
